import { h, Component, Fragment } from 'preact'
import 'core-js'
import SelectFilter from './SelectFilter'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class Filter extends Component {
  render() {
    return (
      <div className="c-housing-filters">
        <div className="c-housing-filters__container">
          {Object.entries(this.props.filters).map(([tax, value]) => {
            let defaultOption =
              tax === 'house_status'
                ? 'Huurstatus'
                : tax === 'house_type'
                ? 'Type woning'
                : tax === 'house_capacity'
                ? 'Personen'
                : tax === 'house_bedrooms'
                ? 'Slaapkamers'
                : 'Selecteer een optie'

            return (
              <SelectFilter
                currentValue={value}
                taxonomy={tax}
                defaultOption={defaultOption}
                onSelectTerm={this.props.onSelectTerm}
              />
            )
          })}
          <div class="c-housing-filters__filler" />
        </div>

        {this.props.filtered ? (
          <div
            className="c-housing-filters__reset"
            onClick={this.props.onResetFilter}
          >
            <svg className="c-icon c-housing-filters__icon">
              <use href="#close" xlinkHref="#close" />
            </svg>
            RESET FILTERS
          </div>
        ) : null}
      </div>
    )
  }
}

export default Filter



// WEBPACK FOOTER //
// ./src/js/housing/containers/Filters.js